import { render, staticRenderFns } from "./CuposAsignacionCnsr.vue?vue&type=template&id=f7260624"
import script from "./CuposAsignacionCnsr.vue?vue&type=script&lang=js"
export * from "./CuposAsignacionCnsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports